<template>
    <div class="relative">
        <!-- Контейнер для скролла -->
        <div ref="tabsWrapper"
            class="flex space-x-2 overflow-x-auto no-scrollbar border rounded-t-2xl">
            <button v-for="tab in tabs" :key="tab.id" @click.prevent="selectTab(tab.id)"
                class="whitespace-nowrap px-4 py-3 border-b-2 transition font-medium"
                :class="activeTab === tab.id
          ? 'border-baseColor'
          : 'border-transparent text-gray-600 md:hover:text-gray-800'">
                {{ tab.title }}
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'

// принимаем список табов и опционально внешний active
const props = defineProps({
    tabs: {
        type: Array,
        required: true,
        // формат элементов: { id: String|Number, title: String }
    },
    modelValue: {
        type: [String, Number],
        default: null
    }
})
const emit = defineEmits(['update:modelValue'])

const activeTab = ref(props.modelValue ?? (props.tabs[0] && props.tabs[0].id))

// при клике меняем активный и эмитим вверх
function selectTab(id) {
    activeTab.value = id
    emit('update:modelValue', id)
}

// синхронизируем с внешним v-model, если его поменяли снаружи
watch(
    () => props.modelValue,
    val => {
        if (val !== activeTab.value) activeTab.value = val
    }
)

// (опционально) можно скроллить к активному табу при монтировании/смене
const tabsWrapper = ref(null)
onMounted(() => {
    watch(activeTab, id => {
        const btn = tabsWrapper.value.querySelector(`[data-id="${id}"]`)
        if (btn) {
            btn.scrollIntoView({ behavior: 'smooth', inline: 'center' })
        }
    }, { immediate: true })
})
</script>

<style scoped>
/* прячем скроллбар */
.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
